import { GET_MEDWATCH_DETAILS, GET_CIMOS_DETAILS } from '../types'

const INITIAL_STATE = {
  allReportsMedWatch: [],
  allreportsCimos: [],
}

const reportMedWatch = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_MEDWATCH_DETAILS:
      return {
        ...state,
        allReportsMedWatch: payload,
        loader: false,
      }
    case GET_CIMOS_DETAILS:
      return {
        ...state,
        allreportsCimos: payload,
        loader: false,
      }
    default:
      return state
  }
}

export default reportMedWatch
